import { defineComponent as _defineComponent } from 'vue'
import useRouter from '@/composables/useRouter'
import { Icons } from '@/icons/icons'
import LfLabelButtonComponent from '@/components/forms/buttons/label/LfLabelButtonComponent.vue'
import { LabelButtonVariant } from '@/components/forms/buttons/types/ButtonTypes'
import { useI18n } from 'vue-i18n-composable'
import { URLS } from '@/router/routes/urlRoutes'
import AlertListItemComponent from './AlertListItemComponent.vue'
import useActionsAlertsMessages from '@/components/Navigation/AppBarToolbarItems/contextMenus/composables/useActionsAlertsMessages'
import { ListStatus } from '@/store/modules/alertsMessages/alertsMessagesTypes'

// ROUTER

export default /*#__PURE__*/_defineComponent({
  __name: 'AlertsListComponent',
  setup(__props) {

const { goToRoute } = useRouter()

// TRANSLATIONS
const { t } = useI18n()
const texts = {
  alerts: t('navigation.alerts_menu.alerts'),
  loadError: t('navigation.alerts_menu.load_error'),
  viewMoreAlerts: t('navigation.alerts_menu.more_alerts'),
  link: t('navigation.alerts_menu.no_data.link'),
  noData: t('navigation.alerts_menu.no_data.text')
}

// DATA
const icon = {
  noData: Icons.ARCHIVE_EMPTY,
  error: Icons.CLOSE_ROUND
}
const alertConfigPanelURL = `/panel-configuracion/alertas`
const path = 'navigation.alerts_menu.no_data.link_text'

// COMPOSABLES
const { status, alertsMessagesList } = useActionsAlertsMessages()

// METHODS
function goToAlertsMessagesView() {
  goToRoute({
    name: URLS.ALERT_MESSAGES
  })
}

return { __sfc: true,goToRoute, t, texts, icon, alertConfigPanelURL, path, status, alertsMessagesList, goToAlertsMessagesView, LfLabelButtonComponent, LabelButtonVariant, AlertListItemComponent, ListStatus }
}

})